<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="on-love">
<h1 style="padding-top:150px;">On Love</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?62ff9b78